module.exports = __webpack_public_path__ + "static/media/upsell-tab-amazing.7e1dfc53.png";